/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-11-23 12:11:43
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-11-24 12:19:15
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorText/index.tsx
 */
import React from 'react';
import RouteBlock from '@/src/constrains/SalesChannelPreviewPageComponents/BasicPageHOC/RouteBlock';
import PageWrapper from '../../../constrains/SalesChannelPreviewPageComponents/PageWrapper/PageWrapper';
import { PreviewStyleSwitch } from '@/src/constrains/SalesChannelPreviewPageComponents/PreviewContainer';
import { RightConfigWrapper } from '@/src/layout';
import BasicPageHOC from 'src/constrains/SalesChannelPreviewPageComponents/SalesChannelContentBasicPageHOC';
import { dispatch } from 'src/store';
import {
  fetchText,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getHasModified,
  getLoaded,
  getSalesChannel,
  getSalesChannelName,
  getState,
  getSubmitStamp,
  getTheme,
  getThemes,
  onCollapseOpen,
  onErrorChange,
  onReset,
  submitText,
  validation,
} from './slice';
import {
  convertDataFromReduxToServer,
  defaultTextListBySize,
  textThemeValidation,
  title,
} from './tool';
import { useDispatch, useSelector } from 'react-redux';
import ErrorProcessingComponent from '@/src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC/ErrorProcessingComponent';
import Item from './Item';
function SalesChannelEditorText(props: any) {
  const {
    onDiscard,
    onGoBack,
    submitData,
    hasModified,
    salesChannel,
    salesChannelName,
    currentStyle,
    currentSize,
    isOnPrimaryLanguage,
  } = props;
  const _d = useDispatch();
  const themes = useSelector(getThemes());
  const list = defaultTextListBySize(currentSize);
  return (
    <React.Fragment>
      <RouteBlock hasModified={hasModified} />
      <PageWrapper
        headerConfig={{
          hasModified,
          submit: submitData,
          salesChannelContentData: salesChannel || {},
          salesChannelName: salesChannelName,
          onDiscard,
          onGoBack,
        }}
        leftChild={
          <PreviewStyleSwitch
            style={currentStyle}
            styleChild={
              <div
                style={{
                  height: 10000,
                  backgroundColor: 'transparent',
                  // margin: '0 auto',
                }}>
                123
              </div>
            }
            normalChild={null}
          />
        }
        rightChild={
          <RightConfigWrapper
            title={'Text Theme'}
            elements={[
              {
                body: (
                  <React.Fragment>
                    {list.map((v) => {
                      const data = themes[v];
                      return (
                        <ErrorProcessingComponent
                          key={v}
                          getCollapseOpenStatus={getCollapseOpenStatus}
                          onCollapseOpen={onCollapseOpen}
                          headerProps={{
                            dotsFunction: [
                              {
                                key: 'Reset Style',
                                body: 'Reset Style',
                                isDangerous: true,
                                onClick: () =>
                                  _d(onReset({ type: v, size: currentSize })),
                              },
                            ],
                            hasDots: true,
                            hideDotsWhenNotPrimary: true,
                          }}
                          id={v}
                          getContent={() => getTheme(v)}
                          title={title(v)}
                          getErrorDisplay={getCollapseValidationMsgDisplay}
                          onErrorChange={onErrorChange}
                          validation={(x, _p) => {
                            return textThemeValidation(x);
                          }}
                          getSubmitStamp={getSubmitStamp}
                          renderComponent={(errorProcessingProps: any) => (
                            <Item
                              theme={data}
                              type={v}
                              errorProcessingProps={errorProcessingProps}
                              isOnPrimaryLanguage={isOnPrimaryLanguage}
                            />
                          )}
                        />
                      );
                    })}
                  </React.Fragment>
                ),
                key: 'headerTop',
              },
            ]}
          />
        }
      />
    </React.Fragment>
  );
}

export default BasicPageHOC(SalesChannelEditorText, {
  getState,
  previewSizeInParams: true,
  convertDataFromReduxToServer,
  submit: submitText,
  getHasModified,
  getSalesChannel,
  getSalesChannelName,
  getLoaded,
  validation,
  queryData: (params, qParams) => {
    const { contentUuid } = params;
    dispatch(
      fetchText({
        uuid: contentUuid,
        params: qParams,
      }),
    );
  },
});
